<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Transfers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Stock Transfers",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stock Transfers Report",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsStockTransfersDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "source",
          sortable: true,
          label: "SOURCE",
        },
        {
          key: "source_type",
          sortable: true,
          label: "SOURCE TYPE",
        },
        {
          key: "destination",
          sortable: true,
          label: "DESTINATION",
        },
        {
          key: "products",
          sortable: true,
          label: "NO. OF PRODUCTS",
        },
        {
          key: "sentby",
          sortable: true,
          label: "SENT BY",
        },
        {
          key: "senton",
          sortable: true,
          label: "SENT ON",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      receive: {
        id: "",
        items: [],
        date: moment(new Date()).format("YYYY-MM-DD"),
        destination: 0,
        filterTransfers: {},
      },
      filterTransfers: {
        product: "",
        branch_id: 0,
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 50,
      },
      products: [],
      amountError: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("stocktransfer", [
      "SaveStatus",
      "StockTransfersData",
      "StockTransfersDataPagination",
      "filterStatus",
      "StockTransfersDataPaginated",
    ]),
    ...mapGetters("setting", ["BusinessSettings", "GeneralSettings"]),
    ...mapGetters("auth", ["branchid", "Branches"]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.IsStockTransfersDataServerPaginated
        ? this.StockTransfersDataPagination?.total || 0
        : this.StockTransfersData
        ? this.StockTransfersData.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStockTransfersDataServerPaginated) {
          return (
            this.StockTransfersDataPagination?.per_page ||
            this.filterTransfers.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStockTransfersDataServerPaginated) {
          this.filterTransfers.per_page = value;
          this.filterTransfers.page = 1;
          this.FetchTransfers(this.filterTransfers);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StockTransfersDataPaginated &&
          this.StockTransfersDataPagination
          ? this.StockTransfersDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StockTransfersDataPaginated) {
          this.filterTransfers.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          this.closeModal(this.modal_id);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchTransfers: "stocktransfer/fetchStockTransfers",
      Receive: "stocktransfer/Receive",
      FetchSettings: "setting/fetchBusinessSettings",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchProducts: "products/fetchProducts",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    ViewItems(data) {
      this.products = data.items;
    },

    PrintItems(id) {
      this.$router.push(`/stock/transfer_print/${btoa(id)}`);
    },

    ViewReceiveModal(data) {
      this.receive.id = data.id;
      this.receive.items = JSON.parse(JSON.stringify(data.items));
      this.receive.items.forEach((item) => {
        if (item.qt_rcv === undefined) {
          item.qt_rcv = item.qty_sent;
        }
      });
    },

    ReceiveItems(modalId) {
      this.modal_id = modalId;
      this.receive.filterTransfers = this.filterTransfers;
      this.Receive(this.receive);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    FilterReport() {
      const requiresServerPagination =
        this.filterTransfers.datefrom !== this.filterTransfers.dateto;

      let payload = { ...this.filterTransfers };

      if (requiresServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      } else {
        this.clientCurrentPage = 1;
      }

      this.FetchTransfers(payload);
    },

    handlePageChange(newPage) {
      if (this.IsStockTransfersDataServerPaginated) {
        this.filterTransfers.page = newPage;
        this.FetchTransfers(this.filterTransfers);
      }
    },
  },

  created() {
    this.FetchTransfers(this.filterTransfers);
    this.FetchSettings();
    this.FetchBranches();
    this.FetchGeneralSettings();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="row">
                <div class="col-md-8"></div>
                <div class="col-md-4 mb-2" v-if="branchid == 0">
                  <label>FILTER BY BRANCHES</label>
                  <model-list-select
                    :list="Branches ? Branches : []"
                    v-model="filterTransfers.branch_id"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Branch"
                    @input="FilterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-9">
                <h4 class="card-title">Stock Transfer History</h4>
              </div>
            </div>
            <div class="row">
              <!-- Search -->
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filterTransfers.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filterTransfers.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                <model-list-select
                  :list="
                    Products
                      ? [
                          { product_name: '', name: 'All Products' },
                          ...Products.map((p) => ({
                            product_name: p.name || p.product_name || '',
                            name: p.name || p.product_name || '',
                          })),
                        ]
                      : []
                  "
                  v-model="filterTransfers.product"
                  option-value="product_name"
                  option-text="name"
                  placeholder="Select Product"
                  @input="FilterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-3 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="FilterReport()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
              <!-- End search -->
            </div>
            <div class="row py-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <!-- Server-side pagination -->
              <div>
                <DataTable
                  :columns="fields"
                  :rows="StockTransfersData || []"
                  :total-rows="rows"
                  :pagination="StockTransfersDataPagination"
                  :server-pagination="IsStockTransfersDataServerPaginated"
                  :loading="filterStatus"
                >
                  <template #cell(index)="{ index }">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                  </template>
                  <template #cell(source)="{ row }">{{ row.source }}</template>
                  <template #cell(source_type)="{ row }">{{
                    row.source_type
                  }}</template>
                  <template #cell(destination)="{ row }">{{
                    row.destination
                  }}</template>
                  <template #cell(products)="{ row }">{{
                    row.products
                  }}</template>
                  <template #cell(sentby)="{ row }">{{ row.sentby }}</template>
                  <template #cell(senton)="{ row }">{{ row.senton }}</template>
                  <template #cell(status)="{ row }">
                    <div v-if="row.status == 'Pending'" class="text-warning">
                      {{ row.status }}
                    </div>
                    <div
                      v-else-if="row.status == 'Partially Received'"
                      class="text-primary"
                    >
                      {{ row.status }}
                    </div>
                    <div v-else class="text-success">
                      {{ row.status }}
                    </div>
                  </template>
                  <template #cell(actions)="{ row }">
                    <b-button-group>
                      <b-button
                        size="sm"
                        variant="primary"
                        v-b-modal.view-item-modal
                        @click="ViewItems(row)"
                        ><i class="fa fa-eye"></i> View
                      </b-button>
                      <b-button
                        size="sm"
                        variant="info"
                        @click="PrintItems(row.id)"
                        ><i class="fa fa-print"></i> Print
                      </b-button>
                      <b-button
                        v-if="
                          (row.status == 'Pending' &&
                            row.is_destination == 1) ||
                          (row.status == 'Partially Received' &&
                            row.is_destination == 1)
                        "
                        v-b-modal.receive-item-modal
                        variant="success"
                        size="sm"
                        @click="ViewReceiveModal(row)"
                        ><i class="fa fa-arrow-down"></i> Receive
                      </b-button>
                    </b-button-group>
                  </template>
                </DataTable>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="tickets-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal mark as view-item starts -->
    <b-modal id="view-item-modal" size="lg" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">Items That were Transferred</h4></template
      >
      <table class="table table-striped table-bordered table-responsive">
        <thead>
          <tr>
            <th>No</th>
            <th>Item</th>
            <th v-if="GeneralSettings.track_expiries == 1">Batch Number</th>
            <th>Qty Sent</th>
            <th>Qty Received</th>
            <th>Buying Price</th>
            <th>Date Received</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(det, d) in products" :key="d" width="100%">
            <td>{{ d + 1 }}</td>
            <td>{{ det.product }}</td>
            <td v-if="GeneralSettings.track_expiries == 1">
              {{ det.batch_number }}
            </td>
            <td>{{ det.qty_sent }} {{ det.unit }}</td>
            <td>{{ det.qty_received }} {{ det.unit }}</td>
            <td>{{ det.bPrice ? det.bPrice : 0 }}</td>
            <td>{{ det.receivedOn }}</td>
          </tr>
        </tbody>
      </table>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          @click="closeModal('view-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal receive starts -->
    <b-modal id="receive-item-modal" hide-footer>
      <template #modal-title>
        <h4 class="text-warning">Receive Items</h4></template
      >
      <table class="table table-striped table-bordered table-responsive">
        <thead>
          <tr width="100%">
            <th width="10%">No</th>
            <th width="25%">Item</th>
            <th width="25%" v-if="GeneralSettings.track_expiries == 1">
              Batch Number
            </th>
            <th width="20%">Qty Sent</th>
            <th width="20%">Qty Received</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(det, index) in receive.items" :key="index" width="100%">
            <td width="10%">{{ index + 1 }}</td>
            <td width="25%">{{ det.product }}</td>
            <td width="25%" v-if="GeneralSettings.track_expiries == 1">
              {{ det.batch_number }}
            </td>
            <td width="20%">{{ det.qty_sent }} {{ det.unit }}</td>
            <td width="20%">
              <input
                type="number"
                class="form-control"
                v-model="det.qt_rcv"
                step="any"
                placeholder="Qty Received"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Receive Date</label>
            <input type="date" v-model="receive.date" class="form-control" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label>Destination <span class="text-danger">*</span></label>
            <div class="input-group">
              <select class="form-control" v-model="receive.destination">
                <option value="0">Shop</option>
                <option
                  value="1"
                  v-if="BusinessSettings ? BusinessSettings.store == 1 : false"
                >
                  Store
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('receive-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-arrow-down"></i> Receive
          <b-spinner variant="light" small label="Receiving"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="ReceiveItems('receive-item-modal')"
        >
          <i class="fa fa-arrow-down"></i> Receive
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
